import React from 'react'
import "./TableComponent.css"

const TableComponent = ({ data, title, height = '450px' }) => {
    if (!data.length) return <p>No data available</p>

    const columns = Object.keys(data[0])

    return (
    <div className="chart-wrapper">
        <div className="chart-title">{title}</div>

        <div className="table-outer">
            <table className="table table-sm">
            <thead className="table-sticky-head">
                <tr>
                {columns.map(col => (
                    <th key={col}>{col}</th>
                ))}
                </tr>
            </thead>

            <tbody>
                {data.map((row, i) => (
                <tr key={i}>
                    {columns.map(col => (
                    <td
                        key={col}
                        dangerouslySetInnerHTML={{ __html: row[col] }}
                    />
                    ))}
                </tr>
                ))}
            </tbody>
            </table>
        </div>
        </div>
    )
}

export default TableComponent
